/**
 * Bug #438
 * @Author Anupama P
 * @Date 1 Jul 2021
 */
export default function Wrapper({children, className=null, ...props}) {
    if(props?.keys?.length >= 1 || className || props?.style){ /*Bug #588 - Add div when style is setting - Modified by Jithin Kuriakose on 03Sept2021*/
        return <div className={className} {...props}>{children}</div>
    }
    return children;
}
/** End */
